// 标签权限map
export const LABEL_KEY = {
  ADD_CATEGORY: 'cdp:label:addCategory',
  DEL_CATEGORY: 'cdp:label:delCategory',
  UPDATE_CATEGORY: 'cdp:label:updateCategory',
  SHOW_LABEL: 'cdp:label:showLabel',
  ADD_LABEL: 'cdp:label:addLabel',
  DEL_LABEL: 'cdp:label:delLabel',
  UPDATE_LABEL: 'cdp:label:updateLabel',
  COPY: 'cdp:label:copyLabel',
  DOWNLOAD: 'cdp:label:downLoadLabel',
};
// 分群权限map
export const CROWD_KEY = {
  GET: 'label:crowd:get',
  ADD: 'label:crowd:add',
  DEL: 'label:crowd:del',
  UPDATA: 'label:crowd:update',
  COPY: 'label:crowd:copy',
  DOWNLOAD: 'label:crowd:upload',
};
// 配置权限map
export const SYS_KEY = {
  //账号管理
  USER_ADD: 'system:user:add',
  USER_REMOVE: 'system:user:remove',
  USER_EDIT: 'system:user:edit',
  USER_QUERY: 'system:user:query',
  USER_PWD: 'system:user:resetPwd',
  //用户组管理
  GROUP_ADD: 'system:userGroup:add',
  GROUP_DEL: 'system:userGroup:delete',
  GROUP_EDIT: 'system:userGroup:edit',
  GROUP_LIST: 'system:userGroup:list',
  GROUP_ADDUSER: 'system:userGroup:addUser',
  //角色管理
  ROLE_ADD: 'system:role:add',
  ROLE_REMOVE: 'system:role:remove',
  ROLE_EDIT: 'system:role:edit',
  ROLE_QUERY: 'system:role:query',
  ROLE_SAVE: 'system:role:save',
};
// 忠诚度权限map
export const LOYALTY_KEY = {
  // 奖励事件
  EVENT_ADD: 'crm:reward:event:add',
  EVENT_DELETE: 'crm:reward:event:delete',
  EVENT_UPDATE: 'crm:reward:event:update',
  EVENT_DETAIL: 'crm:reward:event:detail',
  EVENT_PAGE: 'crm:reward:event:page',
  EVENT_CONFIG_UPDATE: 'crm:reward:config:update',
  EVENT_STOP: 'crm:reward:event:stop',
  // 批量发放积分
  PLAN_SAVE: 'crm:send-point-plan:save',
  PLAN_REVOKE: 'crm:send-point-plan:revoke',
  PLAN_DETAILPAGE: 'crm:send-point-plan:detailPage',
};

// 忠诚度存量会员管理map
export const STOCKMEMBER_KEY = {
  // 下载
  EVENT_DOWNLOAD: 'system:hisMember:stockDownload',
  // 查看
  EVENT_VIEW: 'system:hisMember:stockList',
};
// 客户洞察权限map
export const USER_KEY = {
  //客户列表
  USER_LIST: 'system:customer:list',
  USER_DETAIL: 'system:customer:list',
  USER_POINTS: 'system:customer:changePoints',
  USER_GRADE: 'system:customer:changeGrade',
  USER_GROWTH: 'system:customer:changeGrowth',
  USER_EXPORT: 'system:customer:exportData',
};
// 数据看板map
export const BOARD_KEY = {
  //rfm
  EVENT_ADD: 'cdp:board:rfm:add',
  EVENT_DELETE: 'cdp:board:rfm:delete',
  EVENT_UPDATE: 'cdp:board:rfm:update',
  EVENT_DETAIL: 'cdp:board:rfm:get',
  EVENT_PAGE: 'cdp:board:rfm:list',
  EVENT_RECALCULATE: 'cdp:board:rfm:recalculate',
};
// 群体洞察权限map
export const GROUP_KEY = {
  GROUP_LIST: 'label:portrait:get',
  GROUP_DELETE: 'label:portrait:del',
  GROUP_ADD: 'label:portrait:add',
  GROUP_UPDATE: 'label:portrait:update',
  GROUP_DOWNLOAD: 'label:portrait:upload',
};

// 维度模型导入权限
export const DIMENSION_KEY = {
  DATA_IMPORT: 'user:goodsCollect:updateGoodsByExcel',
  TABLE_EDIT: 'system:spu:edit',
};

// 商品管理权限
export const GOODSMANAGE_KEY = {
  SPU_ADD: 'system:spu:add',
  SPU_EDIT: 'system:spu:edit',
  SPU_DELETE: 'system:spu:delete',
  SPU_LIST: 'user:dimension:list',
};

// 实物资产
export const PHYSICAL_ASSET_KEY = {
  LIST: 'member:product:list',
  ADD: 'member:product:add',
  UPDATE: 'member:product:update',
  DELETE: 'member:product:delete',
  UPDATE_STOCK: 'member:product:update-stock',
};

// 店铺优惠券
export const COUPON_KEY = {
  LIST: 'member:coupon:list',
  ADD: 'member:coupon:add',
  UPDATE: 'member:coupon:update',
  DELETE: 'member:coupon:delete',
  SEND: 'member:coupon:send',
  REPORT: 'member:coupon:report',
};

// 积分兑换配置
export const EXCHANGE_KEY = {
  LIST: 'member:product-instance:list',
  ADD: 'member:product-instance:add',
  UPDATE: 'member:product-instance:update',
  DELETE: 'member:product-instance:delete',
  PUBLISH: 'member:product-instance:publish',
};

// 类目管理
export const CATEGORY_KEY = {
  LIST: 'member:category:list',
  ADD: 'member:category:add',
  UPDATE: 'member:category:update',
  DELETE: 'member:category:delete',
  MOVE: 'member:category:move',
  SHOW: 'member:category:show',
};

// 订单列表
export const ORDER_KEY = {
  PRODUCT_LIST: 'member:exchange-order-product:list',
  PRODUCT_DETAIL: 'member:exchange-order-product:detail',
  PRODUCT_SHIP: 'member:exchange-order-product:ship',
  PRODUCT_EXPORT: 'member:exchange-order-product:export',
  PRODUCT_IMPORT: 'member:exchange-order-product:import',
  PRODUCT_TEMPLATE: 'member:exchange-order-product:template',
  COUPON_LIST: 'member:exchange-order-coupon:list',
  COUPON_DETAIL: 'member:exchange-order-coupon:detail',
};

// 商品推荐
export const GOODS_RECOMMEND_KEY = {
  UPDATE: 'member:goodsRecommend:update',
  DELETE: 'member:goodsRecommend:delete',
  IMPORT: 'member:goodsRecommend:import',
  TEMPLATE: 'member:goodsRecommend:template',
  LIST: 'member:goodsRecommend:list',
  ADD: 'member:goodsRecommend:add',
};

// 会员列表
export const MEMBER_LIST_KEY = {
  DETAIL: 'member:memberList:detail',
  POINT: 'member:memberList:changePoint',
  LEVEL: 'member:memberList:changeLevel',
};

// 积分商城头图（装修）
export const INTEGRAL_HEAD_KEY = {
  ADD: 'member:integralMallHead:add',
  EDIT: 'member:integralMallHead:edit',
  DELETE: 'member:integralMallHead:delete',
  UP: 'member:integralMallHead:up',
  DOWN: 'member:integralMallHead:down',
};

// 条款配置
export const TERMS_KEY = {
  ADD: 'member:termsConditions:add',
  CHECK_VERSION: 'member:termsConditions:checkversion',
  NEW_VERSION: 'member:termsConditions:newversion',
  EDIT: 'member:termsConditions:edit',
  DELETE: 'member:termsConditions:delete',
};

// 页面装修-页面配置
export const PAGE_CONFIG_KEY = {
  UPDATE: 'member:pageConfig:update',
  DELETE: 'member:pageConfig:delete',
  CANCEL: 'member:pageConfig:cancel',
  UP: 'member:pageConfig:up',
  DOWN: 'member:pageConfig:down',
};

// 会员权益
export const BENEFITS_KEY = {
  VIEW: 'system:benefits:view',
  SAVE: 'system:benefits:save',
  SWITCH: 'system:benefits:switch-turn',
  SHOP_SWITCH: 'system:benefits:shop:switch-turn',
  DELETE: 'system:benefits:delete',
  SORT_UP: 'system:benefits:sort-up',
  SORT_DOWN: 'system:benefits:sort-down',
};

// 宠物列表
export const PET_KEY = {
  DETAIL: 'pet:petList:details',
};

// 品种管理
export const PET_BREED_KEY = {
  IS_HOT: 'pet:petType:isHot',
  IS_SHOW: 'pet:petType:isShow',
  EDIT: 'pet:petType:edit',
};

// 生命阶段
export const PET_LIFE_STAGE_KEY = {
  EDIT: 'pet:petLifeStage:edit',
};

// 宠物标签
export const PET_TAG_KEY = {
  ADD: 'pet:petTag:add',
  EDIT: 'pet:petTag:edit',
  DELETE: 'pet:petTag:delete',
  SHOW: 'pet:petTag:isShow',
  DATA: 'pet:petTag:data',
  UP: 'pet:petTag:up',
  DOWN: 'pet:petTag:down',
};

// 埋点数据看板
export const TRACK_BOARD_KEY = {
  EXPORT: 'system:trackBoard:export',
};
